// extracted by mini-css-extract-plugin
export default {"historyCollection":"HistoryCollection_historyCollection__9zw1t","rtl":"HistoryCollection_rtl__6ut89"};